import Button from 'components/Button'
import {Col} from 'components/Display'
import Spinner from 'components/Spinner'
import i18n from 'i18n'
import React from 'react'
import services from 'services'
import APIService from 'services/APIService'
import {useFunction} from 'utils/hooks/function'

async function openBillingPortal() {
  const response = await APIService.getBillingPortalLink()
  if (response.ok) {
    window.open(response.body)
  }
}

export default function UserBillingView() {
  const openPortal = useFunction(openBillingPortal)
  const billingService = services.getBillingService()
  const [subscription, isLoadingSubscription] = billingService.subscription.hook()

  const isLoading = isLoadingSubscription
  const openCheckout = useFunction(billingService.openCheckout)

  if (isLoading) {
    return (
      <Col className="flex-1 items-center justify-center">
        <Spinner />
      </Col>
    )
  }

  return (
    <Col className="flex-1">
      {subscription != null && (
        <div className="mb-8">
          <Button
            loading={openPortal.isRunning}
            className="text-white bg-itx-primary-3"
            content={i18n.t('billing.openPortalButtonText')}
            onClick={openPortal}
          />
        </div>
      )}
      {subscription == null && (
        <React.Fragment>
          <div>
            <Button
              className="bg-itx-primary-3 text-white"
              content="Subscribe"
              loading={openCheckout.isRunning}
              disabled={openCheckout.isRunning}
              onClick={openCheckout}
            />
          </div>
        </React.Fragment>
      )}
    </Col>
  )
}
